import { Users } from 'lucide-react'

/**
 * Vacío del listado. Con el filtro del goal portal-correcciones-1 este estado
 * significa «nadie tiene rol todavía» —puede haber gente en la organización sin
 * él—, no «la organización está vacía»: el texto lo dice así.
 */
export function UsersEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-dashed border-line bg-panel p-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-soft text-accent-dark">
        <Users className="h-7 w-7" />
      </div>
      <h2 className="mt-5 font-serif text-2xl font-normal text-ink">
        Aún no hay miembros con rol
      </h2>
      <p className="mt-2 max-w-md text-sm text-ink-muted">
        Invita a alguien por su correo para que comience a colaborar en tu
        organización. Si ya forma parte de ella, la invitación solo le asigna el rol.
      </p>
    </div>
  )
}
